import angular from 'angular';

angular.module('myConsultApp').factory('ManageOrganizationService', ($resource, ENV, Session) => {
  const manageOrganizationService = {};

  const headers = { Authorization: `Bearer ${Session.accessToken}` };

  manageOrganizationService.getGeocode = (param) => {
    const service = $resource(`${ENV.apiEndpoint}/1.0/geocoding/`, {}, { get: { headers } });
    return service.get(param).$promise;
  };

  manageOrganizationService.createOrganization = (data) => {
    const service = $resource(
      `${ENV.apiEndpoint}/1.0/organizations/`,
      {},
      { save: { method: 'POST', headers } },
    );

    return service.save(data).$promise;
  };

  manageOrganizationService.getCities = (data) => {
    const service = $resource(
      `${ENV.apiEndpoint}/1.0/cities/`,
      {},
      { save: { method: 'GET', headers } },
    );
    return service.save(data).$promise;
  };

  manageOrganizationService.getStates = (data) => {
    const service = $resource(
      `${ENV.apiEndpoint}/1.0/states/`,
      {},
      { save: { method: 'GET', headers } },
    );
    return service.save(data).$promise;
  };

  manageOrganizationService.getCountries = (data) => {
    const service = $resource(
      `${ENV.apiEndpoint}/1.0/countries/`,
      {},
      { save: { method: 'GET', headers } },
    );
    return service.save(data).$promise;
  };

  manageOrganizationService.updateOrganizationDetails = (data) => {
    const updateOrg = $resource(
      `${ENV.apiEndpoint}/1.0/organizations/${data.organization.id}/`,
      {},
      { save: { method: 'PUT', headers } },
    );

    return updateOrg.save(data).$promise;
  };

  manageOrganizationService.getOrganizations = (params) => {
    const service = $resource(
      `${ENV.apiEndpoint}/1.0/organization-search/`,
      {},
      { get: { headers } },
    );

    return service.get(params).$promise;
  };

  manageOrganizationService.getOrganizationsByUrl = (url) => {
    const service = $resource(url, {}, { get: { headers } });

    return service.get().$promise;
  };

  manageOrganizationService.getOrganizationDetails = (params) => {
    const service = $resource(
      `${ENV.apiEndpoint}/1.0/organizations/${params.id}/`,
      {},
      { get: { headers } },
    );

    return service.get().$promise;
  };

  return manageOrganizationService;
});
